"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleQueueTableColumns = function (resources) { return [{
        dataField: 'serialNumber',
        text: resources.Request,
        sort: false,
        style: {
            verticalAlign: 'middle'
        }
    }, {
        dataField: 'submissionTime',
        text: resources.SubmissionTime,
        sort: false,
        style: {
            verticalAlign: 'middle'
        }
    }]; };
//# sourceMappingURL=MultipleQueueTableColumns.js.map